'use client';

import { PencilLine } from 'lucide-react';

import { ASSISTANT_THINKING_LABEL } from '@/lib/engage/chat-ui-message';

const DOT_CLASS =
  'h-1.5 w-1.5 animate-bounce rounded-full bg-current opacity-70';

export function ChatThinkingWait({
  showPencil,
  iconClassName = 'h-4 w-4 origin-bottom animate-bounce opacity-70',
}: {
  showPencil: boolean;
  iconClassName?: string;
}) {
  if (showPencil) {
    return (
      <span
        role="status"
        aria-label={ASSISTANT_THINKING_LABEL}
        className="inline-flex items-center"
      >
        <PencilLine className={iconClassName} aria-hidden />
      </span>
    );
  }

  return (
    <span
      role="status"
      aria-label={ASSISTANT_THINKING_LABEL}
      className="inline-flex items-center gap-1.5"
    >
      <span className={DOT_CLASS} />
      <span className={`${DOT_CLASS} [animation-delay:75ms]`} />
      <span className={`${DOT_CLASS} [animation-delay:150ms]`} />
    </span>
  );
}
